import React from 'react';

import certificate1 from '../../assets/images/certificate1.jpg'; // Rename your first certificate image accordingly
import certificate2 from '../../assets/images/certificate2.jpg'; // Rename your second certificate image accordingly

import './Achievements.css';

const Achievements = () => (
  <section className="achievements section-p">
    <div className="container">
      <h2 className="text-center mb-4">Achievements & Recognition</h2>
      <div className="certificates-grid">
        <div className="certificate-card">
          <img src={certificate1} alt="Certificate 1" className="certificate-img" />
          <p className="certificate-title">JITO Nepal Chapter - Certificate of Appreciation</p>
        </div>
        <div className="certificate-card">
          <img src={certificate2} alt="Certificate 2" className="certificate-img" />
          <p className="certificate-title">Plast Nepal Foundation - Certificate of Appreciation</p>
        </div>
      </div>
    </div>
  </section>
);

export default Achievements;